const Spacing = {
  spacing: factor => `${0.25 * factor}rem`
}
export default Spacing
